<template>
    <div>
        <h2>{{$translate('Settings homepage')}}</h2>

        <v-row>
            <v-col md=6 cols=12>
                <div v-if="rootSetting">
                    <div class="d-flex">
                        <v-icon color="zoezi-edit-color">{{rootSetting.c.zoezi.icon}}</v-icon>
                        <h3 class="ml-2">{{rootSetting.config.templateSettings.name}}</h3>
                    </div>

                    <div v-for="prop in rootSetting.props" :key="prop.name">
                        <component-setting v-model="prop.value" :prop="prop" :config="{}" />
                    </div>
                </div>
            </v-col>
            <v-col md=6 cols=12>
                <v-expansion-panels multiple v-model="expanded">
                    <v-expansion-panel v-for="setting in topLevelSettings" :key="setting.config.id" :class="'pl-' + (4*setting.level)" class="my-2">
                        <v-expansion-panel-header>
                            <div class="d-flex">
                                <v-icon color="zoezi-edit-color">{{setting.c.zoezi.icon}}</v-icon>
                                <h3 class="ml-2">{{setting.config.templateSettings.name}}</h3>
                            </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                            <div v-for="prop in setting.props" :key="prop.name">
                                <component-setting v-model="prop.value" :prop="prop" :config="{}" />
                            </div>

                            <v-expansion-panels multiple v-model="setting.expanded">
                                <v-expansion-panel v-for="setting in setting.children" :key="setting.config.id" :class="'pl-' + (4*setting.level)" class="my-2">
                                    <v-expansion-panel-header>
                                        <div class="d-flex">
                                            <v-icon color="zoezi-edit-color">{{setting.c.zoezi.icon}}</v-icon>
                                            <h3 class="ml-2">{{setting.config.templateSettings.name}}</h3>
                                        </div>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                        <div v-for="prop in setting.props" :key="prop.name">
                                            <component-setting v-model="prop.value" :prop="prop" :config="{}" />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>

        <div class="d-flex">
            <v-spacer />
            <v-btn class="zoezi-button-thin mx-2" color="zoezi-edit-color" :disabled="changed.length == 0" @click="save" :loading="saving">{{$translate('Save')}}</v-btn>
            <v-btn class="zoezi-button-thin mx-2" color="zoezi-edit-color" outlined @click="showPage">{{$translate('Show page')}}</v-btn>
        </div>
    </div>
</template>

<script>
import components from '../component.js'
import {cloneDeep, isEqual} from 'lodash';
import ComponentSetting from '../components/ComponentSetting.vue'
export default {
    name: 'zoezi-template-settings',

    zoezi: {
        icon: 'mdi-cogs',
        title: 'Settings homepage'
    },

    components: {
        ComponentSetting
    },

    data: () => ({
        homepage_id: null,
        settings: [],
        unchangedSettings: [],
        saving: false,
        expanded: []
    }),

    computed: {
        changed() {
            let changed = [];
            this.settings.forEach(setting => {
                let uc = this.unchangedSettings.find(u => u.config.id == setting.config.id);
                setting.props.forEach(prop => {
                    let ucprop = uc.props.find(ucp => ucp.name == prop.name);
                    if (!isEqual(ucprop.value, prop.value)) {
                        changed.push({setting, prop});
                    }
                })
            })

            return changed;
        },
        topLevelSettings() {
            return this.settings.filter(s => !s.parent && s.component != 'zoezi-root');
        },
        rootSetting() {
            let s = this.settings.filter(s => !s.parent && s.component == 'zoezi-root');
            return s.length == 1 ? s[0] : null;
        }
    },

    methods: {
        getComponentsWithTemplateSettings(config) {
            let res = [];
            let addTemplateSettings = function(o, parent) {
                if (typeof o !== 'object' || !o) {
                    return;
                }

                let val = null;
                if (o.component && typeof(o.component) === 'string' && o.templateSettings) {
                    let c = components.getComponent(o.component);
                    if (c) {
                        let cprops = components.getComponentProps(o.component);
                        val = {
                            component: o.component,
                            c,
                            props: o.templateSettings.props.map(x => {
                                let cprop = cprops.find(cp => cp.name == x.id);
                                cprop = cloneDeep(cprop);
                                cprop.title = x.title;
                                cprop.value = o.props[x.id];
                                if (x.hint) {
                                    if (!cprop.typeinfo) {
                                        cprop.typeinfo = {};
                                    }
                                    cprop.typeinfo.hint = x.hint;
                                }
                                if (cprop.type == 'html') {
                                    if (!cprop.typeinfo) {
                                        cprop.typeinfo = {};
                                    }
                                    cprop.typeinfo.inline = true;
                                }
                                return cprop;
                            }),
                            config: o,
                            parent,
                            level: parent ? parent.level+1 : 0,
                            children: [],
                            expanded: []
                        }
                    }
                }

                if (val) {
                    res.push(val);
                    if (parent) {
                        // Flattens tree at level 1
                        while (parent.level >= 1) {
                            parent = parent.parent;
                        }
                        
                        parent.children.push(val);
                        //parent.expanded.push(parent.children.length-1);
                    }
                }

                let arr = Array.isArray(o) ? o : Object.values(o);
                arr.forEach(x => addTemplateSettings(x, val || parent));
            };

            addTemplateSettings(config, null);

            return res;
        },
        getAllSettings(updateColors) {
            this.$api.get('/api/homepage/active', {path: '/'}).then(homepage => {
                this.homepage_id = homepage.id;
                components.updateOwnComponents(homepage.config);
                this.settings = this.getComponentsWithTemplateSettings(homepage.config);
                this.expanded = [];//this.settings.filter(s => !s.parent).map((_, index) => index);
                this.unchangedSettings = cloneDeep(this.settings);
                if (updateColors && homepage.config.root) {
                    this.$root.setThemeColors(homepage.config.root.props.colors);
                }
            })
        },
        save() {
            let data = this.changed.map(c => {
                return {id: c.setting.config.id, prop: c.prop.name, value: c.prop.value};
            })

            let updateColors = !this.$root.edit && this.changed.find(x => {
                return x.setting.component == 'zoezi-root' && x.prop.name == 'colors';
            });

            this.saving = true;
            this.$api.post('/api/homepage/templatesettings/change', data, {homepage_id: this.homepage_id}).then(() => {
                this.saving = false;
                this.getAllSettings(updateColors);
            })
        },
        showPage() {
            window.open('/', '_blank')?.focus();
        }
    },
    mounted() {
        this.getAllSettings(true);
        this.$root.showMyBookings = false; // Should probably be a setting instead
    }
}
</script>
